module.exports = __webpack_public_path__ + "img/pax.085ed197.svg";